import { createApp } from 'vue';
import Host from './components/Host.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const app = createApp(Host);
app.component('Datepicker', Datepicker);
app.mount('#app');
